import { createSlice } from '@reduxjs/toolkit';
import { UserRights } from '../../../flights/interop/user-rights';
import { UserRightsExtended } from '../../../types/settings';

export interface UserSliceSate {
    info:
        | {
              isAuthenticated: false;
          }
        | {
              isAuthenticated: true;
              name: string;
          };
    rights: UserRightsExtended;
}

const initialState: UserSliceSate = {
    info: {
        isAuthenticated: false
    },
    rights: {
        showUserMonitors: false,
        canEditCompanyViews: false,
        canEditCompanyThresholds: false,
        canEditCompanyFilterGroups: false,
        canEditCompanyNotes: false,
        customerAdmin: false,
        routeAiEnabled: false,
        showCommandPrototype: false,
        showWatermark: false,
        advancedWeather: false,
        impactsMonitoring: false,
        waypointMonitoring: false,
        ignoreSystemHubPopups: false,
        acarsUpdateNow: false,
        acarsUpdateInterval: false,
        routeAnalytics: false,
        FPMIntegration: false,
        manualFlightDataEntry: false,
        DesktopIntegration: false,
        DtnAviation: false,
        alertCustomEmail: false,
        webSnapshot: false,
        dashboard: false,
        ai: false,
        canGoToFlightInFE: false,
        canGoToFlightInFPM: false,
        canSendDrawObjToFPM: false,
        canSendRouteToFE: false,
        canRequestRouteFromFPM: false,
        canFlightReleaseToFE: false,
        canVerifyRouteInFPM: false,
        canCalcRouteInFPM: false,
        canDeleteDrawObjFromFPM: false,
        canSendUserDrawObjToFPM: false,
        canDeleteUserDrawObjFromFPM: false,
        canRequestMyFleetFromFPM: false,
        canUpdateMyFleetToFPM: false,
        canRequestFlightInfoFromFPM: false,
        canSendFlightInfoToFPM: false,
        companyFeaturesEnabled: false
    }
};

export const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        setRights(state, params: { payload: UserRights }) {
            state.rights = { ...params.payload, companyFeaturesEnabled: state.rights.companyFeaturesEnabled };
        },
        setCompanyFeaturesEnabled(state, params: { payload: boolean }) {
            state.rights.companyFeaturesEnabled = params.payload;
        },
        setAuthenticatedUser(state, params: { payload: { username: string } }) {
            state.info = {
                isAuthenticated: true,
                name: params.payload.username
            };
        },
        setUnAuthenticatedUser(state) {
            state.info = {
                isAuthenticated: false
            };
        }
    }
});

export const { setRights, setAuthenticatedUser, setUnAuthenticatedUser, setCompanyFeaturesEnabled } = userSlice.actions;
